import {
	PLAN_REQUEST_GET,
	// PLAN_SELECTED,
	PLAN_RESPONSE_GET_FAIL,
	PLAN_RESPONSE_GET_SUCCESS,
	DELETE_PLAN_RESPONSE_SUCCESS,
	RESET_PLAN_DELETE,
	PLAN_ADD_MODAL,
	PLAN_REQUEST_POST,
	PLAN_REQUEST_PATCH,
	PLAN_RESPONSE_POST_FAIL,
	PLAN_RESPONSE_PATCH_FAIL,
	PLAN_SELECTED,
	ADD_PLAN_RESPONSE_SUCCESS,
	ADD_PLAN_RESET_SUCCESS_MSG_OR_ERROR,
	DELETE_ACTION_TRIGGER,
	PLAN_EDIT_MODAL,
	SET_PLAN_NAME,
	SET_VALIDITY_TIME,
	SET_RATE_LIMIT,
	SET_PLAN_DESCRIPTION,
	SET_TOTAL_QUOTA,
	SET_UPLOAD_QUOTA,
	SET_DOWNLOAD_QUOTA,
	SET_TIMEOUT_CRITERIA,
	PLAN_REQUEST_EDIT,
	PLAN_RESPONSE_EDIT_FAIL,
	EDIT_PLAN_RESPONSE_SUCCESS,
	SET_PLAN_ID,
	RESET_PLAN_UPDATE,
	PLAN_SELECTED_BULK,
	// RESET_PLAN_EDIT,
} from '../constants/plansConstants';

export const planListReducer = (state = { plans: {} }, action) => {
	switch (action.type) {
		case PLAN_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case PLAN_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				plans: action.payload,
			};
		case PLAN_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const planDeleteReducer =  (state = { successMessageOnDelete:null, deleteError: null, data:[], loading: false}, action) => {
	switch (action.type) {
		case PLAN_REQUEST_PATCH:		
			return {
				...state,
				loading: true,
				deleteError : null
			};	
		case PLAN_RESPONSE_PATCH_FAIL:
			return {
				...state,
				loading: false,
				deleteError: action.payload,
			};
		case DELETE_PLAN_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_PLAN_DELETE: 
			return {
				...state,
				loading: false,
				successMessageOnDelete: null,
				deleteError: null,
				data: []
			}
		default:
			return state;
	}
}
export const planReducer = (
    state = {
        planSelected : {},
		deleteActionTriggered : false,
		planSelectedBulk : {},
    }, 
    action
) => {
	switch (action.type) {
		case PLAN_SELECTED:
			return { 
                ...state,
                planSelected: action.payload
            };
		case DELETE_ACTION_TRIGGER:
		return { 
			...state,
			deleteActionTriggered: action.payload
		};
		case PLAN_SELECTED_BULK:
		return { 
			...state,
			planSelectedBulk: action.payload
		};
		default:
			return state;
	}
};

export const planAddModalReducer = (
    state = {
        planAddModal : false,
    }, 
    action
) => {
	switch (action.type) {
		case PLAN_ADD_MODAL:
			return { 
                ...state,
                planAddModal: action.payload
            };
			
		default:
			return state;
	}
};
export const planAddReducer = (state = { msg: null, error: null, data:[], loading: false, planAddModal: false}, action) => {
	switch (action.type) {
		case PLAN_REQUEST_POST:
			return {
				...state,
				loading: true,
				error : null
			};
		case PLAN_RESPONSE_POST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case ADD_PLAN_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case ADD_PLAN_RESET_SUCCESS_MSG_OR_ERROR:
			return {
				...state,
					loading: false,
					msg: null,
					error: null,
					data: []
			};
			
		default:
			return state;
	}
};
export const planEditModalReducer = (
    state = {
        planEditModal : false,
    }, 
    action
) => {
	switch (action.type) {
		case PLAN_EDIT_MODAL:
			return { 
                ...state,
                planEditModal: action.payload
            };
			
		default:
			return state;
	}
};
export const editValueReducer = (
	state = {
		planValue: '',
		validityValue: '',
		rateValue: '',
		descriptionValue: '',
		totalValue: '',
		uploadValue: '',
		downloadValue: '',
		timeoutCriteriaValue: '',
		planIdValue: '',
		
	},
	action
) => {
	switch (action.type) {
		case SET_PLAN_NAME:
			return {
				...state,
				planValue: action.payload,
			};
			case SET_VALIDITY_TIME:
			return {
				...state,
				validityValue: action.payload,
			};
			case SET_RATE_LIMIT:
			return {
				...state,
				rateValue: action.payload,
			};
			case SET_PLAN_DESCRIPTION:
			return {
				...state,
				descriptionValue: action.payload,
			};
			case SET_TOTAL_QUOTA:
			return {
				...state,
				totalValue: action.payload,
			};
			case SET_UPLOAD_QUOTA:
			return {
				...state,
				uploadValue: action.payload,
			};
			case SET_DOWNLOAD_QUOTA:
			return {
				...state,
				downloadValue: action.payload,
			};
			case SET_TIMEOUT_CRITERIA:
			return {
				...state,
				timeoutCriteriaValue: action.payload,
			};
			case SET_PLAN_ID:
			return {
				...state,
				planIdValue: action.payload,
			};
		default:
			return state;
	}
};

export const planEditReducer =  (state = { successMessageOnEdit:null, deleteError: null, data:[], loading: false , status:null}, action) => {
	switch (action.type) {
		case PLAN_REQUEST_EDIT:		
			return {
				...state,
				loading: true,
				deleteError : null
			};	
		case PLAN_RESPONSE_EDIT_FAIL:
			return {
				...state,
				loading: false,
				deleteError: action.payload,
			};
		case EDIT_PLAN_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
			case RESET_PLAN_UPDATE: 
			return {
				...state,
				loading: false,
				successMessageOnEdit: null,
				deleteError: null,
				data: []
			}
		
		default:
			return state;
	}
}
